import React, { useEffect, useState } from 'react'
import Pagination from '../../../../Shared/Pagination';
import { Modal } from 'antd';
import PrescriptionDetails from '../ViewPrescription/PrescriptionDetails';

function PrecriptionTable({ data , selectedPatient }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPrescription, setSelectedPrescription] = useState({});
    const itemsPerPage = 5;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data?.length / itemsPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [data]);

    const handleClick = (presc) => {
        setIsModalOpen(true);
        setSelectedPrescription(presc);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div>
            <div className={`min-w-full ${data ? 'w-max' : 'w-full'} m-auto rounded-lg flex justify-center py-2`}>
                <table className={`w-full m-0`}>
                    <thead className='bg-brand-White'>
                        <tr>
                            <th>Patient Name</th>
                            <th>Appointment Id</th>
                            <th>Consultation Reason</th>
                            <th>Doctor Name</th>
                            <th>Clinic Name</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                        <tr>
                            <td className='p-2 bg-[#f6f6f6]' colSpan={12}></td>
                        </tr>
                    </thead>
                    <tbody className='text-center'>
                        {
                            currentItems?.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item?.patientName || '-'}</td>
                                    <td>{item?.appointmentId || '-'}</td>
                                    <td>{item?.consultationReason || '-'}</td>
                                    <td>{item?.userName || '-'}</td>
                                    <td>{item?.clinic_Name || '-'}</td>
                                    <td>{item?.consultationDate?.slice(0, 10) || '-'}</td>
                                    <td>
                                        <button
                                            onClick={() => handleClick(item)}
                                            className="text-brand-White p-2 rounded-md cursor-pointer custom_filter disabled:opacity-50 disabled:cursor-not-allowed"
                                        > View prescription</button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className="relative bottom-[-10px] right-8 flex justify-end my-2">
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                    containerClassName="mb-4"
                    buttonClassName="border border-gray-300 md:px-3 px-2 rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-gray-200"
                    activeButtonClassName="bg-blue-500 rounded-full text-white"
                />
            </div>
            <Modal
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                style={{ top: 20 }}
                width={"70%"}
                footer={[]}
                destroyOnClose
            >
                <PrescriptionDetails
                    prescription={selectedPrescription}
                    selectedPatient={selectedPatient}
                />
            </Modal>
        </div>
    )
}

export default PrecriptionTable